import(/* webpackMode: "eager" */ "/app/admin/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/admin/src/components/common/CookieConsent.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/leaflet/dist/leaflet.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/react-hot-toast/dist/index.mjs");
